import { useOffersDetail } from '@services/offers/queries/user/useOfferDetail'
import { useParams } from 'react-router-dom'
import { FlatsWidget } from '@features/flats/components/FlatsWidget'
import { LoadingPage } from '@common/LoadingPage'

export function OfferDetail() {
  const { id } = useParams()

  const { data, isLoading } = useOffersDetail(id)

  if (!data) return null

  if (isLoading) return <LoadingPage />

  return <FlatsWidget flat={data.flat} offer={data} />
}
